export default "__VITE_ASSET__BFiXGuBJ__"